import { produce } from "immer";
import { atom } from "jotai";
import { OnSubmitReturnType } from "shared/features/assignees/type/assigneeType";
import { v4 as uuid } from "uuid";
const assigneeDataAtom = atom<OnSubmitReturnType>({
  apiData: {
    new: [],
    updated: [],
    deleted: [],
  },
  tableData: [],
});

const checklistDataAtom = atom({ items: [] });

const attachmentDataAtom = atom({ apiData: [], uiData: [] });

// action functions
export const assigneeData = atom((get) => get(assigneeDataAtom));

export const checklistData = atom((get) => get(checklistDataAtom));

export const getAttachmentData = atom((get) => get(attachmentDataAtom));

export const setAssigneeData = atom(
  null,
  (get, set, value: OnSubmitReturnType) => {
    set(assigneeDataAtom, value);
  }
);

export const setAssignMe = atom(
  null,
  (
    get,
    set,
    {
      resourceId,
      firstName,
      lastName,
      profilePic,
    }: {
      resourceId: string;
      firstName?: string;
      lastName?: string;
      profilePic?: string;
    }
  ) => {
    set(assigneeDataAtom, (prev) => {
      const uuId = uuid();
      const newData = produce(prev, (draft) => {
        draft.apiData.new.push({
          uuid: uuId,
          first_name: firstName || "",
          last_name: lastName || "",
          profile_image: profilePic || "",
          resource_id: resourceId,
          schedule_times: [
            {
              schedule_uuid: uuid(),
              start_time: null,
              end_time: null,
            },
          ],
        });
        draft.tableData.push({
          uuid: uuId,
          resource_id: resourceId,
          first_name: firstName || "",
          last_name: lastName || "",
          profile_image: profilePic || "",
          start_time: null,
          end_time: null,
          errors: {
            start_time: null,
            end_time: null,
          },
        });
      });
      return newData;
    });
  }
);

export const filterNonAccessAssignees = atom(
  null,
  (get, set, resources: Array<any>) => {
    const oldAssignees = get(assigneeDataAtom);

    let apiData = Array.from(oldAssignees.apiData.new);
    let tableData = Array.from(oldAssignees.tableData);

    apiData = apiData.filter(
      (assignee) =>
        resources.findIndex(
          (resource) => resource.mapping_id === assignee.resource_id
        ) !== -1
    );

    tableData = tableData.filter(
      (assignee) =>
        resources.findIndex(
          (resource) => resource.mapping_id === assignee.resource_id
        ) !== -1
    );

    set(assigneeDataAtom, (prev) => {
      const newData = produce(prev, (draft) => {
        draft.apiData.new = apiData;
        draft.tableData = tableData;
      });
      return newData;
    });
  }
);

export const setChecklistData = atom(null, (get, set, value: any) => {
  set(checklistDataAtom, value);
});

export const setAttachmentData = atom(null, (get, set, value: any) => {
  const responseDataArray = value.map((item: any) => {
    if (item.responseData) return item.responseData;
  });

  set(attachmentDataAtom, {
    apiData: responseDataArray,
    uiData: value,
  });
});
export const resetTicketStore = atom(null, (get, set) => {
  set(assigneeDataAtom, {
    apiData: { new: [], updated: [], deleted: [] },
    tableData: [],
  });
  set(checklistDataAtom, { items: [] });
  set(attachmentDataAtom, { apiData: [], uiData: [] });
});
